import { useState } from "react";
import ArabicConsentModal from "./ArabicConsentModal";

const ConsentMinorArabicUAE = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };
  const programObjectiveHTML = `
  <div dir="rtl" style="text-align: right; font-family: 'Arial Arabic', sans-serif;">

    <div class="program-section">
      <h2>1. الهدف من البرنامج</h2>
      <p>برنامج دعم ماي رأي هو برنامج ("البرنامج") يدعم المرضى الذين وصف لهم عقار دوريكستين ("عقارنا") حيث يساعدهم في اتباع النظام العلاجي الذي يحدده الطبيب المعالج فضلاً عن تزويدهم بالدعم التعليمي حتى يتكيفوا مع حالتهم. ويهدف هذا البرنامج أيضاً إلى تعزيز فهم أفضل للأمراض التي يمكن علاجها بعقارنا وإدارتها من خلال التحليلات والأبحاث المتقدمة التي يتم إجراؤها استناداً إلى مجموعات البيانات المجمعة ومجهولة المصدر الناتجة عن البيانات التي يتم جمعها كجزء من البرنامج.</p>
      
      <p>وهذا البرنامج مقترح ومدعوم من مجموعة سانوفي-أفنتيس (فرع دبي للشركات متعددة الجنسيات) ("مجموعة سانوفي")، وتتولى شركة بياني للرعاية الصحية المنزلية ("مقدم الخدمة") تنفيذه وإدارته نيابة عن مجموعة سانوفي.</p>
      
      <p>وليس الغرض من هذا البرنامج الترويج لعقارنا أو أي منتج آخر من منتجات مجموعة سانوفي كما لا يدعم أي ادعاءات حول فعالية العقار أو سلامته، فهو لا يهدف إلى الترويج بشكل مباشر للعقار أو أي من منتجات مجموعة سانوفي، كما أن المعلومات التي يتم جمعها في إطار تنفيذ البرنامج لا يمكن استخدامها لأغراض تجارية أو تسويقية.</p>
    </div>

    <div class="program-section">
      <h2>2. خدمات الدعم</h2>
      <p>للبرنامج أغراض تعليمية حصرية حيث تم إعداده لتزويدك بمعلومات متخصصة ودعم حالتك من خلال مجموعة من الخدمات يُشار إليها فيما يلي بـ"خدمات الدعم" على النحو المبين أدناه:</p>
      
      <ul>
        <li>ستحصل على الدعم لمساعدتك في إدارة حالتك وعلاجك بشكل أفضل من خلال الممرضين الذين سيتواصلون معك و/أو يلتقون بك حسب احتياجاتك</li>
        <li>سوف تحصل على رقم خط ساخن ومواد تعليمية</li>
        <li>يمكن أن تحصل على خدمات الدعم هذه من خلال قنوات مختلفة من بينها (على سبيل المثال لا الحصر) الاتصال بك من قبل موظفين مدربين ("المعلمين") في الإمارات العربية المتحدة</li>
      </ul>
      
      <p>ولا يعتبر هذا البرنامج بديلاً عن زيارات الطبيب، فلا يمكن لمقدم الخدمة والمعلمين التابعين له تقديم أي مشورة أو معلومات تشكل جزءاً من علاقتك بطبيبك، حيث ينحصر دورهم في تقديم خدمات تعليمية، وهذه الخدمات لا يمكن أن تحل محل المشورة الطبية في أي وقت من الأوقات.</p>
    </div>

    <div class="program-section">
      <h2>3. أنت ومشاركتك في البرنامج</h2>
      <h3>أ. التسجيل في البرنامج والخروج منه</h3>
      <p>التسجيل في البرنامج اختياري ومجاني ويمكنك الخروج من البرنامج في أي وقت ودون إبداء أي أسباب، وينجز طلبك للإلغاء من خلال إرسال إشعار كتابي، موقع وموضح منك، إلى شركة بياني للرعاية الصحية المنزلية عبر عنوان البريد التالي: pspsafety@baytihhc.com أو من خلال بيانات الاتصال الموضحة أدناه: 800 – BAYTI (9955)</p>
      
      <p>ويحق لمجموعة سانوفي بموجب إشعار مسبق إنهاء البرنامج في أي وقت وأي سبب، ويمكن طبياً إيقاف اشتراكك في البرنامج في أي وقت (على سبيل المثال لأسباب طبية). وإذا قررت التوقف عن استخدام العقار فسوف ينتهي اشتراكك في البرنامج تلقائياً حيث أنه يُشترط للاشتراك في البرنامج أن تتناول هذا العقار، لكن يجب أن تطمئن إلى أن قرار الخروج من البرنامج و/أو التوقف عن تناول العقار لن يؤثر بأي شكل من الأشكال على متابعتك الطبية من قبل طبيبك.</p>
      
      <h3>ب. البيانات الشخصية</h3>
      <p>لالستفادة من خدمات الدعم المقدمة من خلال البرنامج يجب عليك تسجيل وتقديم بيانات الاتصال الخاصة بك، كما يجب عليك كجزء من البرنامج تقديم بياناتك الشخصية (الموضحة أدناه) أثناء تواصلك مع مقدم الخدمة والمعلمين التابعين له.</p>
    </div>

    <div class="program-section">
      <p><strong>"البيانات الشخصية":</strong> يقصد بها كافة البيانات الشخصية التي تقدمها كجزء من عملية التسجيل في البرنامج وأثناء تواصلك مع المعلمين أو أي بيانات شخصية قد تقدمها لأغراض تتعلق بخدمات الدعم.</p>
      
      <p><strong>الغرض:</strong> الغرض من جمع بياناتك الشخصية هو تمكين وتسهيل عملية التواصل طوال فترة الاشتراك في البرنامج. يرجى ملاحظة أن بياناتك الشخصية لن تُعالج بطريقة تتعارض مع الغرض الذي جُمعت من أجله.</p>
      
      <p><strong>فئات/محتوى البيانات:</strong> لتحقيق الأغراض المذكورة أعلاه، سيتم جمع ومعالجة البيانات الشخصية التالية وفقاً لما هو موضح في هذا النموذج:</p>
      
      <ul>
        <li>الاسم، رقم الهوية، ومعلومات الاتصال (مثل رقم الجوال والبريد الإلكتروني)</li>
        <li>الجنس، العمر، الجنسية</li>
        <li>تفاصيل التاريخ الطبي، بما في ذلك الأمراض المصاحبة، والأدوية</li>
      </ul>

      <p><strong>الجهة المسؤولة:</strong> سيتم معالجة بياناتك الشخصية بشكل آمن وسري من قبل شركة بياني للرعاية الصحية المنزلية.</p>
      
      <p><strong>طريقة جمع البيانات:</strong> ستُجمع بياناتك الشخصية من خلال الوسائل التالية: النماذج الورقية، النماذج الإلكترونية، المقابلة الشخصية التي تُجرى من قبل موظفي الجهة المسؤولة (عبر الإنترنت أو حضورياً)، الاتصالات عبر التطبيق، الرسائل النصية، البريد الإلكتروني، والمكالمات الهاتفية.</p>
      
      <p><strong>الأساس القانوني:</strong> ستتم معالجة بياناتك الشخصية بناءً على واحد أو أكثر من الأسس التالية: (1) موافقتك، (2) تحقيق مصلحة مشروعة للجهة المسؤولة عن المعالجة والمشاركين في هذا البرنامج، (3) الامتثال للقوانين واللوائح القضائية والقانونية.</p>
      
      <p><strong>مدة المعالجة:</strong> سيتم الاحتفاظ ببياناتك لمدة لا تتجاوز فترة اشتراكك في البرنامج، وذلك وفقاً للمتطلبات المحلية المطبقة، والالتزامات القانونية، والصالح القضائي، والقوانين خارج الحدود الإقليمية، اعتباراً من تاريخ توقيع هذا النموذج.</p>
    </div>

    <div class="program-section">
      <h3>ج. المشاركة والتحويل</h3>
      <p>يجوز مشاركة بياناتك الشخصية مع الأطراف المعنية كجزء من عملية إدارة البرنامج وهذه الأطراف هي: (1) مقدم الخدمة، (2) المعلمين، (3) طبيبك، (4) قسم الدواء والسلامة لدى مجموعة سانوفي، (5) الجهات الصحية.</p>
      
      <p>يتعهد كل طرف من الأطراف المعنية بالامتثال لكافة القوانين واللوائح المحلية أو الدولية التي تحكم خصوصية البيانات كما يلتزم بما يقتضيه جمع بياناتك الشخصية ومعالجتها والحفاظ عليها وحفظها بطريقة سرية وآمنة.</p>
      
      <p>ويتعهد مقدم الخدمة باتخاذ إجراءات فنية وتنظيمية ملائمة في حال استخدام بياناتك الشخصية أو معالجتها بشكل غير قانوني أو غير مصرح به أو في حال فقدانها أو تعديلها أو الإفصاح عنها أو تلقيها أو تضررها عن طريق الخطأ.</p>
      
      <h3>د. حقوق حماية البيانات الشخصية</h3>
      <p>كمشارك في برنامج دعم ماي راي، سيقوم مقدم الخدمة بالرد على جميع استفساراتك المتعلقة بالبرنامج وأي طلبات بخصوص المعلومات التي تقدمها. وفقاً لقوانين حماية البيانات المعمول بها، يحق لك ممارسة حقوق حماية البيانات الخاصة بك، والتي تشمل:</p>
      
      <ul>
        <li>الحق في الوصول إلى بياناتك الشخصية</li>
        <li>تصحيح أي معلومات غير صحيحة</li>
        <li>طلب تقييد المعالجة</li>
        <li>الحصول على معلومات حول أغراض وطرق المعالجة</li>
        <li>طلب تدمير بياناتك الشخصية</li>
        <li>الحصول على بياناتك الشخصية بتنسيق واضح ومقروء</li>
      </ul>

      <p>لممارسة حقوق حماية البيانات الخاصة بك، يمكنك التواصل مع شركة بياني للرعاية الصحية المنزلية عبر:</p>
      
      <p style="text-align: center;">(i)أوالبريد الإلكتروني: pspsafety@baytihhc.com،</p>
      <p style="text-align: center;">(ii) 800 - BAYTI (9955)</p>

      <h3>هـ. إزالة الهوية والاستخدام الثانوي</h3>
      <p>كما ذكر أعلاه، فإن الوصول إلى بياناتك الشخصية كجزء من البرنامج سيكون محدوداً للغاية. خارج نطاق البرنامج، قد تحتاج مجموعة سانوفي والسلطات الصحية إلى إعادة استخدام البيانات التي يوفرها البرنامج لفهم ملف السلامة الخاص بالدواء بشكل أفضل، وذلك لتحسين الإدارة العامة للمرض. وهذا ما يسمى بالاستخدام الثانوي.</p>
    </div>

    <div class="program-section">
      <p>لن تتمكن مجموعة سانوفي من الوصول إلى بياناتك الشخصية، إلا لأسباب تتعلق بسلامة الدواء، وفقاً للشروط المحددة أعلاه. سيتم إزالة الهوية عن بياناتك وتجميعها. وهذا يعني أنه سيتم إزالة جميع المعلومات التي يمكن أن تؤدي إلى تحديد هويتك الشخصية من قاعدة بيانات البرنامج. المعلومات التي ستبقى في قاعدة بيانات البرنامج المجهولة والمجمعة لن توفر أي تفاصيل عنك ولن تسمح بمعرفتك أو الاتصال بك. سيتم استخدام هذه البيانات لأغراض البحث والتحليل الثانوي فقط.</p>
      
      <p>ولفهم المرض وإدارته بشكل أفضل، سيتم معالجة بياناتك دون تحديد هويتك لاستخدامها في المسائل البحثية والتطبيقية المتقدمة وفي المنشورات العلمية، وستبقى بياناتك الشخصية مجهولة الهوية ولن يتم الكشف عنها في أي مرحلة من مراحل البحث.</p>
    </div>

    <!-- Consent Section -->
    <div class="consent-section">
      <h2 style="color: #0065a0; text-align: center; text-decoration-line: underline; font-weight: bolder;">الموافقة</h2>
      
      <p><em>* يجب تعبئتها فقط من قبل المريض نفسه/نفسها أو الوصي القانوني ولا يجوز لمقدم الرعاية الصحية/المعلم أو أي شخص آخر تعبئة هذه الخانات في أي حال من الأحوال.*</em></p>

      <p>أنا ______ ، أب/أم و/أو الوصي القانوني لـ_________، ("القاصر") المقيم حالياً في ______، رقم هاتفي: ______.</p>

      <p>أوافق على تقديم بياناتي الشخصية وبيانات القاصر ذات الصلة إلى مقدم الخدمة/المعلم لتمكين مشاركة القاصر في البرنامج.</p>

      <p>وفي الحدود المذكورة أعلاه، أوافق كذلك على:</p>

      <ul>
        <li>جمع ومعالجة والاحتفاظ ببياناتي الشخصية وبيانات القاصر من قبل طبيب القاصر، مقدم الخدمة/المعلم وسانوفي للسلامة الدوائية والسلطات الصحية، وأفهم أن توقيعي على هذا النموذج لن يخفف من مسؤوليات طبيب القاصر أو مقدم الخدمة بأي حال من الأحوال.</li>
        <li>بالتوقيع على هذه الموافقة، أوافق بصفتي الشخصية كوصي قانوني للقاصر على مشاركته في البرنامج. لدي الأهلية القانونية لإعطاء موافقتي المستنيرة نيابة عن القاصر، بمعنى آخر، أنا أكبر من 21 عاماً وأنا الأب/الأم و/أو الوصي القانوني للقاصر.</li>
        <li>أوافق أيضاً على السماح لسانوفي باستخدام بياناتي المجهولة الهوية لأغراض البحث والتحليلات والنشر العلمي، للمساعدة في زيادة الوعي بالمرض وفهمه وإدارته بشكل أفضل.</li>
      </ul>

      <h3>الاعترافات:</h3>
      <ul>
        <li>أفهم أن أي أحداث متعلقة بالسلامة أو شكاوى المنتجات سيتم الإبلاغ عنها للأطراف المعنية وفقاً لمتطلبات الخصوصية والالتزامات القانونية.</li>
        <li>لقد تأكدت لي أن المشاركة في هذا البرنامج اختيارية ومجانية ويمكنني الانسحاب من البرنامج في أي وقت دون أن يؤثر ذلك على رعايتي الطبية أو إدارة مرضي.</li>
        <li>أقر بعدم تقديم أي تعويض مالي أو اعتبارات أخرى مقابل مشاركتي في هذا البرنامج.</li>
        <li>أفهم أنه سيتم نقل بياناتي الشخصية بين شركة بياني للرعاية الصحية المنزلية، وإدارة السلامة الدوائية والسلطات الصحية.</li>
        <li>أفهم أنني لن أتلقى إشعاراً عند كل نقل لبياناتي الشخصية بين أطراف البرنامج.</li>
      </ul>

      <p>لقد قرأت نموذج الموافقة المستنيرة وفهمت محتواه، وأتيحت لي الفرصة لطرح الأسئلة وتمت الإجابة عليها، وأعطيت الوقت الكافي لمناقشة المعلومات مع الآخرين والقاصر واتخاذ قرار بشأن مشاركة القاصر في البرنامج.</p>

      <p>أفهم أنه يمكنني ممارسة حقوقي في حماية البيانات، بما في ذلك سحب هذه الموافقة، في أي وقت، شفوياً أو كتابياً، دون تقديم أسباب ودون أن يترتب على ذلك أي عواقب سلبية عليّ أو على رعايتي الطبية.</p>

      <p>أؤكد أنني تلقيت وفهمت جميع المعلومات المتعلقة بالبرنامج. أفهم أنه يمكنني طرح الأسئلة في أي وقت. أؤكد أن جميع أسئلتي قد تمت الإجابة عليها وأنني حصلت على الوقت الكافي للتفكير.</p>

    </div>
    </div>
    <div className="form-header" style= "margin-bottom: 2rem; font-family: Arial, sans-serif;">
       <table className="form-metadata" style= "width: 100%; border-collapse: collapse; margin-bottom: 1rem;direction: ltr;display: inline-table; text-align: justify;">
         <tbody style= "border: 1px solid;">
           <tr style= "border: 1px solid;">
             <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">Form Title</strong></td>
             <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">MAT code</strong></td>  
             <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">Approval Date</strong></td>
             <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">Edition</strong></td>
             <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">Last Revision Date</strong></td>
             <td style= "border: 1px solid;"><strong style= "margin-left: 10px;">Next Revision Date</strong></td>
           </tr>
           <tr>
             <td style= "border: 1px solid; padding-left: 10px;">Patient Consent Form- Dupixent (Minors- Arabic)</td>
             <td style= "border: 1px solid; padding-left: 10px;">MAT-AE-2500625/v1/July 2025</td>
             <td style= "border: 1px solid; padding-left: 10px;">July 2025</td>
             <td style= "border: 1px solid; padding-left: 10px;">2</td>
             <td style= "border: 1px solid; padding-left: 10px;">July 2025</td>
             <td style= "border: 1px solid; padding-left: 10px;">July 2027</td>
           </tr>
         </tbody>
       </table>
     </div>
  `;

  const handleSubmitClick = () => {
    if (isChecked) {
      setShowModal(true);
    }
  };


  return (
    <>
      <ArabicConsentModal
        show={showModal}
        onClose={() => setShowModal(false)}
        programObjectiveHTML={programObjectiveHTML}
        formType='Minor'
        Language="Arabic"
      />
      <div
        className="consent-container"
        dir="rtl"
        style={{
          textAlign: 'right',
          fontFamily: "'Arial Arabic', 'sans-serif'",
          marginRight: "3%",
          marginTop: "0px"
        }}
      >
        <h1>نموذج إقرار موافقة المريض القاصر عقار دوبكسنت</h1>
        <div dangerouslySetInnerHTML={{ __html: programObjectiveHTML }} />
        <div className="form-controls">
        <div className="" >
            <label>
              <input
                type="checkbox"
                required
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              نا أوافق
            </label>
          </div>
          <button
            style={{
              background: "rgb(25, 118, 210)",
              border: "none",
              color: "rgb(255, 255, 255)",
              padding: "10px",
              textAlign: "center",
              textDecoration: "none",
              display: "inline-block",
              fontSize: "14px",
              cursor: isChecked ? "pointer" : "not-allowed",
              opacity: isChecked ? 1 : 0.3,
              borderRadius: '4px',
            }}
            onClick={isChecked ? handleSubmitClick : null}
            disabled={!isChecked}
          >
            تقديم
          </button>
        </div>
      </div>
    </>
  );
};

export default ConsentMinorArabicUAE;
